import { $sxhr } from "../../services/http";

export default {
  dicParamsGetTree: info => {
    return $sxhr.post("dic/params/getTree", info);
  },
  upload: info => {
    return $sxhr.upload(info);
  },
  getAnonymousId: info => {
    return $sxhr.post("anonymous/getId", info);
  },
  serchBusiness: info => {
    return $sxhr.post("api/business/search", info);
  }
};
